enum ActivityStatus {
  TRACK = 1,
  FILL = 2,
  LOAD_SHIP = 3,
  RECEIVE = 4,
  EMPTY = 5
}

export {ActivityStatus}